'use client';

import { useRouter } from 'next/navigation';

interface UniversitySwitcherProps {
  current: string;
  universities: Array<{ id: string; name: string; slug: string }>;
  lang: string;
}

export function UniversitySwitcher({ current, universities, lang }: UniversitySwitcherProps) {
  const router = useRouter();
  const isId = lang === 'id';

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="uni-switcher" className="shrink-0 text-xs font-medium text-text-secondary">
        {isId ? 'Universitas:' : 'University:'}
      </label>
      <select
        id="uni-switcher"
        value={current}
        onChange={(e) => router.push(`/${e.target.value}`)}
        className="w-full content-card px-3 py-2 text-sm text-text-primary focus:border-accent-primary focus:outline-none focus:ring-1 focus:ring-accent-primary"
      >
        {universities.map((u) => (
          <option key={u.id} value={u.slug}>
            {u.name}
          </option>
        ))}
      </select>
    </div>
  );
}
